import * as React from 'react';
import CustomSignIn from './customSignIn';
import ForgotPassword from './forgotPassword';
import MFAToken from './MFAToken';
import RequireNewPassword from './requireNewPassword';
import AuthPage from './AuthPage';
import AppLoader from 'core/ui/components/AppLoader';
import TermsAndConditions from './termsAndConditions';
import { Suspense } from 'react';

interface IProps {
  handleStateChange?: (newState: any) => void;
  authState?: any;
  onAuthEvent?: (state: any, event: any) => void;
  onStateChange?: (newState: any, data: any) => void;
  authData?: any;
}

const CustomAuthWrapper: React.FC<IProps> = (props: IProps) => {
  const [email, setEmail] = React.useState('');
  const [successMessage, setSuccessMessage] = React.useState('');
  const triggerAuthEvent = (event: any) => {
    const state = props.authState;
    if (props.onAuthEvent) {
      props.onAuthEvent(state, event);
    }
  };

  const changeState = (state: any, data: any, emailAddress: string) => {
    if (props.onStateChange) {
      props.onStateChange(state, data);
    }
    if (state === 'signIn' && data === 'success') {
      setEmail(emailAddress);
      setSuccessMessage('Password reset success. Sign in to continue.');
    } else if (state === 'signIn' && data !== 'success') {
      setEmail('');
    }
    if (state === 'signedIn') {
      setEmail('');
      setSuccessMessage('');
    }
    triggerAuthEvent({
      type: 'stateChange',
      data: state,
    });
  };

  if (props.authState === 'signedIn') {
    return null;
  }

  if (props.authState === 'loading') {
    return <AppLoader showGradient={true} />;
  }

  return (
    <AuthPage>
      {props.authState === 'signIn' && (
        <Suspense fallback={<AppLoader showGradient={true} />}>
          <CustomSignIn
            changeState={changeState}
            authData={props.authData}
            successMessage={successMessage}
            emailAddress={email}
          />
        </Suspense>
      )}

      {props.authState === 'requireNewPassword' && (
        <RequireNewPassword changeState={changeState} authData={props.authData} />
      )}

      {props.authState === 'forgotPassword' && <ForgotPassword changeState={changeState} />}

      {props.authState === 'termsAndConditions' && <TermsAndConditions changeState={changeState} />}

      {props.authState === 'confirmSignIn' && <MFAToken changeState={changeState} authData={props.authData} />}
    </AuthPage>
  );
};

export default CustomAuthWrapper;
